import React, {useState, useEffect} from "react";
import {getImageFromFilesbyKey} from "../../../../_metronic/_helpers";

export const VideosSearchSlide = ({
    preview = false,
    className,
    style,
    handleMatchClick = () => {},
    video: {id, name, title, level, type_id, files = [], searchMatches},
}) => {
    const [thumbnail, setThumbnail] = useState("");

    useEffect(() => {
        if (files !== null && files !== undefined) {
            const _thumbnail = getImageFromFilesbyKey(files, id, "imgLandscape", type_id);
            setThumbnail(_thumbnail);
        }
    }, [files]);

    return (
        <div className={`searchResultSlide card card-custom card-stretch link-card shadow ${className}`} style={style}>
            <div className="flex cursor-pointer" onClick={() => handleMatchClick(id)}>
                <div
                    className={`${
                        preview ? "cropped-preview" : ""
                    } searchResultSlide_image w-100 card-img-top bg_image_cover`}
                    style={{
                        backgroundImage: !preview ? `url(${thumbnail})` : "",
                    }}
                />
                <div className="card-header border-0">
                    <h5 className="searchResultSlide_title font-weight-bolder text-dark-75 text-hover-primary m-0 elipsis_3lines">
                        {title || name}
                    </h5>
                    <span className="font-weight-bold text-muted">{level}</span>
                </div>
            </div>
            {/* body: */}
            <div className="searchResultSlide_body">
                <div className="searchResultSlide_content custom-scroll-area">
                    {searchMatches &&
                        searchMatches.map((match, i) => (
                            <div className="text-muted font-weight-bold font-size-sm d-block mb-4" key={i}>
                                <span
                                    className="font-weight-bold font-size-sm text-primary text-hover-info cursor-pointer"
                                    onClick={() => handleMatchClick(id, match.startTime)}
                                >
                                    {match.startTime.replace(/\.\d+/, "") || ""}
                                    <span className="px-1">·</span>
                                </span>
                                {match.context ? (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: match.context,
                                        }}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};
